import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/AuthRedirect/AuthRedirect.js
const AuthRedirect = () => (
  <NoSettings text="Completes Auth0 sign-in. Keep it as the only section of the auth-redirect page. No settings." />
);

export default AuthRedirect;
